import React from "react";
import InvolvementRoleService from "../../../../../../../../../services/InvolvementRoleService";
import InvolvementRoleTypeService from "../../../../../../../../../services/InvolvementRoleTypeService";
import ClassificationService from "../../../../../../../../../services/ClassificationService";
import PartyRoleService from "../../../../../../../../../services/PartyRoleService";
import { labels } from "../../../../../../../../../localization/labels";
import SubControlComponent from "../../../../../../../page/SubControlComponent";
import CommonUtil from "../../../../../../../../../utils/CommonUtil";
import {
  validateEntity,
  involvementRoleValidationRules as validationRules
} from "../../../../../../../../../validators/validationRules";
import { paths } from "../../../../../../../../paths";
import PathUtil from "../../../../../../../../../utils/PathUtil";
import InvolvementRole from "./InvolvementRole";
import RouteUtil from "../../../../../../../../../utils/RouteUtil";
import { activeFilterPageInfo } from "../../../../../../../../../services/FilteringUtils";

class InvolvementRoleContainer extends SubControlComponent {
  constructor(props) {
    super(props);
    this.state = {
      id: this.resolveItemId(),
      partyRoleId: PathUtil.pathParameter(this.props, "partyRoleId"),
      partyId: PathUtil.pathParameter(this.props, "partyId"),
      partyRoleType: RouteUtil.getLocationParameter(
        this.props,
        "partyRoleType"
      ),
      isChanged: false
    };
    this.state = this.initialState(this.state);

    this.involvementRoleService = new InvolvementRoleService();
    this.involvementRoleTypeService = new InvolvementRoleTypeService();
    this.partyRoleService = new PartyRoleService();
    this.classificationService = new ClassificationService();
  }

  componentDidUpdate(prevProps) {
    const newId = this.resolveItemId();

    if (newId !== PathUtil.pathParameter(prevProps, "id")) {
      this.state.id = newId;
      this.state.partyId = PathUtil.pathParameter(this.props, "partyId");
      this.state.partyRoleId = PathUtil.pathParameter(
        this.props,
        "partyRoleId"
      );
      this.state.partyRoleType = RouteUtil.getLocationParameter(
        this.props,
        "partyRoleType"
      );
      this.setState(this.initialState(this.state));
      this.loadData();
    }
  }

  initialState = state => {
    return {
      ...state,
      entity: {
        operations: [],
        classifications: []
      },
      possibleInvolvementRoleTypes: [],
      oldEntity: undefined,
      disabled: true,
      isNew: true
    };
  };

  getComponentTitle = () => {
    return this.state.entity ? this.state.entity.name : undefined;
  };

  componentDidMount() {
    this.loadPartyRole();
    this.loadPossibleInvolvementRoleTypes();
    this.loadData();
  }

  loadPartyRole = () => {
    this.prepareCall(
      this.partyRoleService.getEntityById(
        this.state.partyRoleId,
        this.onPartyRoleLoad,
        this.messageHandler.handleError
      )
    );
  };

  onPartyRoleLoad = data => {
    this.setState({
      partyRole: data
    });
  };

  loadPossibleInvolvementRoleTypes = () => {
    this.prepareCall(
      this.involvementRoleTypeService.getEntitiesWithParams(
        this.state.partyRoleType._links.involvementRoleTypes.href,
        activeFilterPageInfo,
        undefined,
        this.onPossibleInvolvementRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
  };

  onPossibleInvolvementRoleTypesLoad = data => {
    if (data._embedded && data._embedded.content) {
      this.setState({
        possibleInvolvementRoleTypes: data._embedded.content
      });
    }
    this.loadPossibleParentInvolvementRoleTypes();
  };

  loadPossibleParentInvolvementRoleTypes = () => {
    this.prepareCall(
      this.involvementRoleTypeService.getEntitiesWithParams(
        this.state.partyRoleType._links.parentInvolvementRoleTypes.href,
        activeFilterPageInfo,
        undefined,
        this.onPossibleParentInvolvementRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
  };

  onPossibleParentInvolvementRoleTypesLoad = data => {
    if (data._embedded && data._embedded.content) {
      var possibleInvolvementRoleTypes = this.state
        .possibleInvolvementRoleTypes;
      Array.prototype.push.apply(
        possibleInvolvementRoleTypes,
        data._embedded.content
      );
      this.setState({
        possibleInvolvementRoleTypes: possibleInvolvementRoleTypes
      });
    }
  };

  loadData = () => {
    if (this.state.id) {
      this.loadInvolvementRole(this.state.id);
    } else {
      this.setComponentTitle(labels.involvementRoleType);
    }
  };

  loadInvolvementRole = id => {
    this.prepareCall(
      this.involvementRoleService.getEntityById(
        id,
        this.onLoadInvolvementRole,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadInvolvementRole = data => {
    this.setState({
      entity: { ...data },
      oldEntity: { ...data },
      disabled: false,
      isNew: false
    });
    this.loadInvolvementRoleType();
  };

  loadInvolvementRoleType = () => {
    this.prepareCall(
      this.involvementRoleTypeService.getEntityById(
        this.state.entity.involvementRoleTypeId,
        this.onLoadInvolvementRoleType,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLoadInvolvementRoleType = data => {
    const { entity } = this.state;
    entity.involvementRoleType = data;
    this.setState({
      entity: entity
    });
  };

  getSubArrayPath = () => {
    return "operations";
  };

  validator = entity => {
    return validateEntity(entity, validationRules.involvementRole);
  };

  onEntitySave = () => {
    const entity = {
      ...this.state.entity
    };
    entity.partyRole = this.state.partyRole;

    if (!this.state.id) {
      this.saveNewEntity(entity);
    } else {
      this.updateEntity(entity);
    }
  };

  saveNewEntity = entity => {
    this.prepareCall(
      this.involvementRoleService.postEntity(
        entity,
        this.onSaveLoad,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  updateEntity = entity => {
    this.prepareCall(
      this.involvementRoleService.putEntity(
        entity,
        this.onSaveLoad,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  onSaveLoad = data => {
    if (this.state.id) {
      this.loadData();
    } else {
      const itemPath = PathUtil.adminItemsPath(
        {
          path: paths.USERS,
          partyId: this.state.partyId
        },
        {
          path: paths.USERROLES,
          partyRoleId: this.state.partyRoleId
        },
        { path: paths.INVOLVEMENTROLES, id: data.id }
      );
      this.changePath(itemPath, data.id, {
        partyRoleType: this.state.partyRoleType
      });
    }
  };

  onChange = event => {
    let { entity } = this.state;
    const path = event.target.id;
    CommonUtil.setDeepOnStringPath(entity, path, event.target.value);
    const disabled = !this.validator(entity);
    this.setState({ entity, disabled });
  };

  setInitialEntityPropertyState = (propertyName, initialPropertyState) => {
    const { entity } = this.state;
    entity[propertyName] = initialPropertyState;
    this.setState({
      entity: entity
    });
  };

  setClassificationsOnEntity = classifications => {
    let entity = this.state.entity;
    if (entity.classifications) {
      entity.classifications = classifications;
      this.setState({
        entity,
        isChanged: true
      });
    }
  };

  classificationsSelectionInitialPageSize() {
    return 12;
  }

  render() {
    return (
      <InvolvementRole
        {...this.renderProps()}
        involvementRole={this.state.entity}
        possibleInvolvementRoleTypes={this.state.possibleInvolvementRoleTypes}
        messageHandler={this.messageHandler}
        breadcrumbsHandler={this.breadcrumbsHandler}
        disabled={this.state.disabled}
        validationRules={validationRules.involvementRole}
        onSave={this.onEntitySave}
        onChange={this.onChange}
        setInitialEntityPropertyState={this.setInitialEntityPropertyState}
        setClassificationsOnEntity={this.setClassificationsOnEntity}
        editable={true}
        initialPageSize={this.classificationsSelectionInitialPageSize}
      />
    );
  }
}

export default InvolvementRoleContainer;
